import { Link } from "react-router-dom";
import { Button } from "components/buttons/Button";
import { memo } from "react";
import ChevronIcon from "components/icons/linear/chevron-left.svg?react";
import "./BackButton.scss";

interface IBackButton {
  onClick?: () => void;
  link?: string;
}

export const BackButton: React.FC<IBackButton> = memo(({
  onClick,
  link,
}) => {
  const onClickHandle = () => {
    onClick && onClick();
  };

  return (
    <div className="BackButton">
      {link ? (
        <Link className="Button Button_primary Button_s Button_isRound" to={link} aria-label="Link to the previous page">
          <ChevronIcon />
        </Link>
      ) : (
        <Button variant="primary" size="s" onClick={onClickHandle} round aria-label="Back button">
          <ChevronIcon />
        </Button>
      )}
    </div>
  );
});
